import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePickListTemplateSelection = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePickListTemplateSelection);
};
